export default "__VITE_ASSET__Di_Qaejn__"